import React, {useState, useEffect, useRef} from 'react'
import FilterIcon from './filter.svg'
import {Button, ChipsSelect, Modal, SelectInput, TOAST} from "retro/index";
import {DateRangePicker} from "react-date-range";
import moment from "moment";
import Moment from "moment/moment";
import {get} from "App/Network/Axios";
import Input from "retro/Inputs/Input";

export default function FilterDropDown({amountFilter=[],onClose,masters = [],shown=false,choices={},setFilters,filters={},types=[],dateFilter,selectionType,labels=[],filterIcondisplay=true, color, dateChip=true, space, compare=false, marginTop='mt4', marginBottom='mb2'}){
	const [filterType,setFilterType] = useState(undefined)
	const [masterType,setMasterType] = useState(undefined)
	const [selected,setSelected] = useState([])
	const OFFICE = useRef();
	const MIN = useRef();
	const MAX = useRef();
	const [amountModal,setAmountModal] = useState(undefined)
	const [Picker, setPicker] = useState(false)
	const [AllOffices, setAllOffices] = useState([]);
	const [Range, setRange] = useState( {
		startDate: moment().add(-31, 'days')._d,
		endDate: moment().add(1, 'days')._d,
		key: 'selection'
	});
	const [office,setOffice] = useState(undefined)
	const allOffices = () => {
		get(`/offices/all`,(e,r)=>{
			if(r){
				setAllOffices(r.items)
			}else if(e){
				TOAST.handleError(e)
			}
		})
	}
	useEffect(()=>{
		if(masterType==="Office"){
			allOffices()
		}
	},[masterType])
	useEffect(()=>{
		if(filterType){
			setSelected(filters[filterType.toLowerCase()]||[])
		}
	},[filterType])
	let baseFilters = () => {
		let ft = {};
		Object.keys(filters).forEach(item=>{
			ft[item] = []
		})
		return ft;
	}
	const master = ()=> {
		if(masterType){
			if(masterType==="Office"){
				return (
					<Modal style={{marginTop:'70px'}} width={400} title={"Add Office Filter"} onClose={()=>{setFilterType(undefined),setMasterType(undefined)}} blank={true}>
						<SelectInput ref={OFFICE} onChange={val=>setOffice(val)} options={AllOffices.map(office=>({label:office.name, value: office.name}))} label='Select Office' placeholder='Select Office'/>
						<Button onClick={()=>{
							if(office) {
								let newFilters = {...filters}
								let allOffices = newFilters.offices || []
								allOffices.push(office)
								newFilters.offices = allOffices;
								setFilters(newFilters)
								setMasterType(undefined)
								setOffice(undefined)
							}
						}} className="btn btn-black" margin="mt4">
							Add
						</Button>
					</Modal>
				)
			}
		}
	}
	const filter = () => {
		if(filterType){
			let allChoices = choices?.[filterType?.toLowerCase()];

			let selection=selectionType?.[filterType?.toLowerCase()]||"multiple"
			return (
				<Modal width={400} title={filterType} onClose={()=>{setFilterType(undefined)}} blank={true}>
					{
						allChoices?.map(item=>{
							return (
								<div key={item} className="flex  mt1">
									<input checked={selected.includes(item)} onChange={(e) => {
										if(selection==="single"){
											setSelected([item])
										}else{
											if(selected.includes(item)) {
												let newSelected = [];
												selected.forEach(a=>{
													if(a!==item){
														newSelected.push(a);
													}
												})
												setSelected(newSelected)
											}else {
												let newSelected = [...selected];
												newSelected.push(item)
												setSelected(newSelected)
											}
										}
									}} className="form-check-input mr1" style={{marginTop:4}} type="checkbox"/>
									<div className="flex flex-1 center-vertically horizontally">
										<div className="flex-1 ml1">
											<p style={{fontSize: 14}}>{item}</p>
										</div>
									</div>
								</div>
							)
						})
					}
					<Button onClick={()=>{
						let newFilters = {...filters}
						newFilters[filterType.toLowerCase()] = selected;
						setFilters(newFilters)
						setFilterType(undefined)
						setSelected([])
					}} className="btn btn-black" margin="mt4">
						Apply
					</Button>
				</Modal>
			)
		}
	}
	let allItems = []
	Object.values(filters).map(item=>{
		allItems.push(...item)
	})
	return (
		<>
			{
				master()
			}
			{filter()}
			{
				shown && <div style={{background:color ? `${color}` : "rgb(250, 251, 251)", overflowX:'auto'}} className={`pl2 FadeIn-Effect flex horizontally center-vertically ${marginTop} ${marginBottom} pr2 pt1 pb1 rounded-sm`}>
					<div className="flex-1 flex horizontally center-vertically ">
					{filterIcondisplay && <img src={FilterIcon} style={{width:14}} className="mr4"/>}
						{
							dateFilter &&
							<div onClick={() => {
								setPicker(true)
							}} className={`flex pointer horizontally  ${space?space : ''} center-vertically`}>
								<i className="fa-calendar fa mr2"/> <p
								style={{width: 125}}
								className="fw-500 text-truncate">{dateFilter.range?`${Moment(dateFilter.range.startDate).format("DD MMM")} - ${Moment(dateFilter.range.endDate).format("DD MMM YY")}`:'Add Date Filter'}</p>
							</div>
						}
						{
							amountFilter?.length>0 && <div onClick={() => {
								setAmountModal(true)
							}} className="flex pointer  horizontally ml2 center-vertically">
								<i className="fa-money-bill fa mr2"/> <p
								style={{width: 125}}
								className="fw-500 text-truncate">{amountFilter?.value?.max ? `B/w ${amountFilter?.value?.min} - ${amountFilter?.value?.max}` : `Add Amount Filter`}</p>
							</div>
						}
						{
							types.map(item=>{
								return (
									<div onClick={()=>{
										setSelected([])
										setFilterType(item)
									}} className="flex horizontally pointer btn-paper btn center-vertically" style={{padding:'6px 0'}}>
										<p className="fw-500 mr1">
										{labels?.filter((i)=>item===i?.value)?.[0]?.label||item}
										</p>
										<i className="fa fa-chevron-down mr2"/>
										{compare && <p className='mr2'>v/s</p>}
										{compare=false}
									</div>
								)
							})
						}
						{
							masters.map(item=>{
								return (
									<div onClick={()=>{
										setMasterType(item)
									}} className="flex horizontally pointer btn-paper ml2 btn center-vertically" style={{padding:'6px 0'}}>
										<p className="fw-500 mr2">
											{item}
										</p>
										<i className="fa fa-chevron-down"/>
									</div>
								)
							})
						}
					</div>
					{onClose && <i className="fa fa-close pointer" onClick={onClose}/>}
				</div>
			}
			{
				(allItems.length >0 || (dateFilter && dateFilter.range))  && <div className="mt2 mb1 flex horizontally center-vertically pl2 flex-wrap">
					{
						allItems.map(item=>{
							return (
								<div key={item} className="chip mb0">
									{item}
								</div>
							)
						})
					}
					{
						dateChip && dateFilter && dateFilter.range && <div className="chip mb0">
							{Moment(dateFilter.range.startDate).format("DD MMM")} - {Moment(dateFilter.range.endDate).format("DD MMM YY")}
						</div>
					}
			   { (allItems.length>0 || dateChip) && <div onClick={()=>{
						setFilters(baseFilters())
						if(dateChip) {
							dateFilter?.setRange(undefined)
						}
					}} className="mt0 pointer">
						<i className="fa fa-close mr1"/>Clear
					</div>}
				</div>
			}

			{
				Picker ?
					<Modal width={400} blank={true} contentStyle={{
						margin: 0
					}} onClose={() => setPicker(undefined)}
						   title={'Select Dates'}
						   description='Select dates from the calender'>
						<div className='daterange-wrapper'>
							<DateRangePicker
								editableDateInputs={true}
								onChange={item => {
									setRange(item.selection);
									if (item.selection.startDate !== item.selection.endDate) {
										setPicker(undefined)
										dateFilter.setRange({
											startDate: moment(item.selection.startDate).startOf('day').valueOf(),
											endDate: moment(item.selection.endDate).endOf('day').valueOf()
										})
									}
								}}
								direction="horizontal"
								moveRangeOnFirstSelection={false}
								ranges={[Range]}
								rangeColors={['#000']}
							/>
						</div>
					</Modal>
					: <></>
			}
			{
				amountModal && <Modal description="Enter details below to add amount filter" title="Add Amount Filter" onClose={()=>{
					setAmountModal(undefined)
				}}>
					<div className="flex horizontally center-vertically">
						<Input ref={MIN} defaultValue={`${amountFilter?.value?.min}`} label="Min Amount" className="mr1 flex-1" type="number"/>
						<Input ref={MAX} defaultValue={`${amountFilter?.value?.max}`} label="Max Amount" className="ml1 flex-1" type="number"/>
					</div>
					<Button className="btn btn-black" margin="mt2" onClick={()=>{
						let min = parseInt(MIN.current.value,10);
						let max = parseInt(MAX.current.value,10);
						if(min >= 0 && max>=0) {
							amountFilter.setAmountFilter({
								min,max
							})
							setAmountModal(false)
						}
					}}>
						Apply Filter
					</Button>
				</Modal>
			}
		</>
	)
}
